import type { FC } from 'react'
import { FertigationSystems } from './FertigationSystems';
import Climate from './Climate';

const Fertigationmain : FC = () => {
  return (
    <>
      <FertigationSystems />
      <Climate />
    </>
  )
}

export default Fertigationmain;
